__turbopack_context__.v({
  "picture": "banner-picture-component-module-scss-module__oXVqCa__picture",
  "picture__ai-marker--max-1023": "banner-picture-component-module-scss-module__oXVqCa__picture__ai-marker--max-1023",
  "picture__ai-marker--max-767": "banner-picture-component-module-scss-module__oXVqCa__picture__ai-marker--max-767",
  "picture__ai-marker--min-1024": "banner-picture-component-module-scss-module__oXVqCa__picture__ai-marker--min-1024",
  "picture__ai-marker--min-768": "banner-picture-component-module-scss-module__oXVqCa__picture__ai-marker--min-768",
  "picture__element": "banner-picture-component-module-scss-module__oXVqCa__picture__element",
  "picture__element--full-width": "banner-picture-component-module-scss-module__oXVqCa__picture__element--full-width",
  "picture__wrapper": "banner-picture-component-module-scss-module__oXVqCa__picture__wrapper",
});
